<template>
    <TableLayout :permissions="['business:devicerole:query']">
        <!-- 搜索表单 -->
        <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
            <el-form-item label="门禁组名称" prop="name">
                <el-input v-model="searchForm.name" placeholder="请输入门禁组名称" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <section>
                <el-button type="primary" @click="search">搜索</el-button>
                <el-button @click="reset">重置</el-button>
            </section>
        </el-form>
        <!-- 表格和分页 -->
        <template v-slot:table-wrap>
            <ul class="toolbar" v-permissions="['business:devicerole:create', 'business:devicerole:delete']">
                <li><el-button type="primary" @click="$refs.operaDeviceRoleWindow.open('新建门禁角色')" icon="el-icon-plus" v-permissions="['business:devicerole:create']">新建</el-button></li>
                <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['business:devicerole:delete']">删除</el-button></li>
            </ul>
            <el-table
                v-loading="isWorking.search"
                :data="tableData.list"
                stripe
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="name" label="门禁组名称" min-width="100px"></el-table-column>
                <el-table-column prop="memberNum" label="使用人数" min-width="100px"></el-table-column>
                <el-table-column prop="isDefault" label="是否默认" min-width="100px">
                    <template slot-scope="{row}">
                        <el-switch
                            @change="changeIsDefault($event, row.id)"
                            v-model="row.isDefault"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            :active-value="0"
                            :inactive-value="1">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="containPermissions(['business:devicerole:update', 'business:devicerole:delete'])"
                    label="操作"
                    min-width="120"
                    fixed="right"
                >
                    <template slot-scope="{row}">
                        <el-button type="text" @click="edit(row)" icon="el-icon-edit" v-permissions="['business:devicerole:update']">编辑</el-button>
                        <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:devicerole:delete']">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
                :pagination="tableData.pagination"
            >
            </pagination>
        </template>
        <!-- 新建/修改 -->
        <OperaDeviceRoleWindow ref="operaDeviceRoleWindow" @success="handlePageChange"/>
    </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaDeviceRoleWindow from '@/components/business/OperaDeviceRoleWindow'
import { updateStatusById } from '@/api/business/deviceRole'
export default {
  name: 'DeviceRole',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaDeviceRoleWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        name: '',
        isdeleted: 0,
        type: '2'
      }
    }
  },
  created () {
    this.config({
      module: '门禁角色',
      api: '/business/deviceRole',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    changeIsDefault (r, id) {
      updateStatusById({ isDefault: r, type: 2, id })
        .finally(() => {
          this.search()
        })
    },
    edit (row) {
      if (row.doorIds) {
        row.radio = 1
        row.doorIds = row.doorIds.split(',')
        row.doorIds = row.doorIds.map(item => Number(item))
      } else {
        row.radio = 0
        row.doorIds = []
      }
      this.$refs.operaDeviceRoleWindow.open('编辑门禁角色', row)
    }
  }
}
</script>
